import { ScrollView, View } from 'react-native';
import { HelperText, IconButton, Text, useTheme } from "react-native-paper";
import { Avatar } from "react-native-paper";
import React, { useEffect, useRef, useState } from "react";
import Global from '../constants/global';
import ReactToPrint from 'react-to-print';
import { MaterialIcons } from '@expo/vector-icons';
import { useSelector } from 'react-redux';

const pageStyle = `

  @media all {
    .pagebreak {
      display: none;
    }
  }

  @media print {
    .pagebreak {
      page-break-before: always;
    }
  }
`;


export default function FinalMarksheet({ navigation, route }) {
    // const marks = useSelector(s => s.list.Marksheets)
    const marks = useSelector(s => s.list.FinalMarksheet)

    const [data, setData] = useState({ list: [], year: 0 })
    // const print = [6, 43, 29, 34]
    useEffect(() => {
        if (marks) {
            const m = []
            marks.sheets.map(s => {
                m.push({ ...s })
            })
            m.sort((a, b) => a.roll - b.roll)
            const n = m.filter((a, b) => !a.left)
            setData({ list: n, year: marks.year })
        }
    }, [marks])
    const ht = 27
    const bw1 = 3
    const bw2 = 2
    const ref = useRef()
    const t = useTheme()
    let pg1 = 2


    return <ScrollView horizontal style={{ flex: 1, alignSelf: "stretch" }}>
        <View style={{ minWidth: 700 }}>
            {route?.params?.blockPrint !== true && <View style={{ flexDirection: "row" }}>
                <IconButton icon="arrow-left" style={{}} onPress={() => navigation.goBack()} />
                <ReactToPrint
                    pageStyle={pageStyle}
                    trigger={() => <div style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: t.colors.primary, color: t.colors.onPrimary, padding: 5, borderRadius: 5, paddingRight: 10 }}><MaterialIcons style={{ marginLeft: 5, marginRight: 5 }} name="print" color={t.colors.onPrimary} />Print</div>}
                    content={() => ref.current}
                />

            </View>}
            <div ref={ref} style={{ display: "block", width: '100%', marginLeft: "2%", marginRight: "2%" }}>
                <style type="text/css" media="print">{"@page { size: portrait}"}</style>

                {data?.list?.map(value => {

                    // const got = print.find(g => value?.roll == g)
                    let cnd = 0
                    // //console.log("Value", value)
                    pg1 = pg1 == 2 ? 1 : 2
                    const PASS = value?.status == "Pass"
                    return  <div style={{ pageBreakInside: "avoid", paddingBottom: pg1 == 1 ? 75 : 0 }}>
                        <div style={{ width: '100%', borderWidth: bw1, borderStyle: "solid" }}>
                            <div style={{ display: "flex", position: "relative", flexDirection: "column", backgroundColor: t.dark ? "transparent" : "#DCDCDC", borderBottomWidth: bw2, borderBottomStyle: "solid", alignItems: "center", justifyContent: "center" }}>

                                <View style={{ flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                                    <Avatar.Image style={{ marginTop: 5, marginEnd: 10 }} size={60} source={{ uri: require("../assets/images/LOGO.jpg") }} />
                                    <View>
                                        <Text variant="headlineMedium" style={{ fontWeight: "900", marginTop: 10 }}>શ્રી ઠક્કરબાપા વિદ્યામંદિર</Text>
                                        <Text variant="titleMedium" style={{ paddingLeft: 10 }}>ઠક્કરબાપાનગર, અમદાવાદ-૩૮૨૩૫૦</Text>
                                    </View>
                                </View>
                                <View style={{ alignItems: "center", justifyContent: "center", flex: 1, flexDirection: "row" }}>
                                    <Text variant="titleLarge" style={{ textAlign: "center", fontWeight: "bold" }}>વાર્ષિક પરિણામ</Text>
                                    <Text variant="titleLarge" style={{ textAlign: "center", fontWeight: "bold" }}> ({data?.year}-{data?.year - 1999}) </Text>
                                </View>
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", marginTop: 5, marginLeft: 10 }}>
                                <View style={{ flex: 1, flexDirection: "row" }}>
                                    <View style={{ flex: 1, flexDirection: "row" }}>
                                        <Text variant="titleMedium" style={{}}>વિદ્યાર્થી નું નામ   :   </Text>
                                        <Text variant="titleMedium" style={{ fontWeight: "900", textDecorationLine: "underline" }}>{value?.name}</Text>
                                    </View>
                                    <View style={{ flex: 1 }}>
                                        <Text variant="titleMedium" style={{ marginBottom: 10, flex: 1, fontWeight: "900" }}>{value?.std} {value?.div}</Text>
                                    </View>
                                </View>
                                <View style={{ flex: 1, flexDirection: "row" }}>
                                    <View style={{ flex: 1, flexDirection: "row" }}>
                                        <Text variant="titleMedium" style={{ fontWeight: "bold" }}>રોલ નં - {value?.roll}</Text>
                                        <Text variant="titleMedium" style={{ fontWeight: "bold" }}>               GR નં - {value?.gr}</Text>
                                    </View>
                                    <View style={{ flex: 1, flexDirection: "row" }}>
                                        <Text variant="titleMedium" style={{ flex: 1, fontWeight: "bold" }}>UID નં - {value?.uid}    </Text>
                                    </View>
                                </View>
                            </div>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                <View style={{ width: "70%", alignSelf: "stretch", borderRightWidth: 2, borderStyle: "solid" }}>
                                    <View style={{ alignItems: "center", justifyContent: "center", paddingLeft: 5, backgroundColor: t.dark ? "transparent" : "#DCDCDC", flexDirection: "row", borderTopWidth: bw2, borderStyle: "solid", borderBottomWidth: bw2 }}>
                                        <View style={{ height: (ht * 1.25), flex: 3, borderRightWidth: bw2, borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                            <Text variant="titleMedium" style={{ textAlign: "center" }}>અ.નં</Text>
                                        </View>

                                        <View style={{ height: (ht * 1.25), flex: 20, borderRightWidth: bw2, borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                            <Text variant="titleMedium" style={{ textAlign: "center" }}>વિષય</Text>
                                        </View>

                                        <View style={{ height: (ht * 1.25), flex: 5, borderRightWidth: bw2, borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                            <Text variant="titleSmall" style={{ textAlign: "center" }}>કુલ ગુણ</Text>
                                        </View>

                                        <View style={{ height: (ht * 1.25), flex: 7, alignItems: "center", justifyContent: "center", borderRightWidth: bw2, }}>
                                            <Text variant="titleSmall" style={{ textAlign: "center" }}>મેળવેલ ગુણ</Text>
                                        </View>
                                        <View style={{ height: (ht * 1.25), flex: 7, alignItems: "center", justifyContent: "center", borderRightWidth: bw2, }}>
                                            <Text variant="titleSmall" style={{ textAlign: "center" }}>સિદ્ધિ ગુણ</Text>
                                        </View>
                                        <View style={{ height: (ht * 1.25), flex: 7, alignItems: "center", justifyContent: "center", }}>
                                            <Text variant="titleSmall" style={{ textAlign: "center" }}>કૃપા ગુણ</Text>
                                        </View>
                                    </View>
                                    {

                                        value?.subjects?.map((subject, sr) => {


                                            let showM = subject.marks
                                            showM = Global.getDoubleZero(showM)

                                            const toShow = !(subject?.totalMarks == 0)
                                            cnd = toShow ? cnd + 1 : cnd
                                            return (
                                                toShow ? <View style={{ alignItems: "center", justifyContent: "center", paddingLeft: 5, flexDirection: "row", borderBottomWidth: bw2, borderStyle: "solid" }}>
                                                    <View style={{ height: ht, flex: 3, borderRightWidth: bw2, borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                                        <Text variant="titleMedium" style={{ textAlign: "center", fontWeight: "600" }}>{cnd}</Text>
                                                    </View>

                                                    <View style={{ height: ht, flex: 20, borderRightWidth: bw2, borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                                        <Text variant="titleMedium" style={{ textAlignVertical: "center", overflow: "hidden", fontWeight: "600" }}> {subject.name}</Text>
                                                    </View>
                                                    <View style={{ height: ht, flex: 5, borderRightWidth: bw2, borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                                        <Text variant="titleMedium" style={{ fontWeight: "900", textAlignVertical: "center", textAlign: "center" }}> {subject.isPractical ? "" : "100"}</Text>
                                                    </View>

                                                    <View style={{ flexDirection: "row", height: ht, flex: 7, justifyContent: "center", borderRightWidth: bw2, }}>
                                                        <Text variant="titleMedium" style={{ fontWeight: "900", textAlign: "center", textDecorationLine: subject.status == "Fail" ? "underline" : "none" }}>
                                                            {subject.isPractical ? Global.getGrade(showM) : showM}</Text>
                                                    </View>
                                                    <View style={{ flexDirection: "row", height: ht, flex: 7, justifyContent: "center", borderRightWidth: bw2, }}>
                                                        {(PASS && subject.sgiven) ? <Text variant="bodyMedium" style={{ fontWeight: "bold", color: "red", padding: 0 }}>
                                                            {(subject.sgiven ? "+" + subject.sgiven : "")}</Text> : <></>}
                                                    </View>
                                                    <View style={{ flexDirection: "row", height: ht, flex: 7, justifyContent: "center", }}>
                                                        {(PASS && subject.kgiven) ? <Text variant="bodyMedium" style={{ fontWeight: "bold", color: "green", padding: 0 }}>
                                                            {(subject.kgiven ? "+" + subject.kgiven : "")}</Text> : <></>}
                                                    </View>
                                                </View> : <></>)
                                        })
                                    }
                                    {/* {//console.log(value)} */}
                                    <View style={{ backgroundColor: t.dark ? "transparent" : "#DCDCDC", paddingLeft: 5, flexDirection: "row", borderBottomWidth: bw2 }}>
                                        <Text variant="titleMedium" style={{ height: ht, fontWeight: "900", flex: 23, textAlign: "center", borderRightWidth: bw2, borderStyle: "solid" }}>કુલ ગુણ</Text>
                                        <Text variant="titleMedium" style={{ height: ht, fontWeight: "900", flex: 5, textAlign: "center", borderRightWidth: bw2, borderStyle: "solid" }}>{value?.finalFrom}</Text>
                                        <Text variant="titleMedium" style={{ height: ht, fontWeight: "900", flex: 7, textAlign: "center", borderRightWidth: bw2, }}>{value?.finalTotal}</Text>
                                        {/* <Text variant="titleMedium" style={{ height: ht, fontWeight: "900", flex: 7, textAlign: "center", borderRightWidth: bw2, }}>{exam?.selfMarks ? exam?.selfMarks : (exam?.subjectMarks ? exam?.subjectMarks : "0")}</Text> */}
                                        <Text variant="titleMedium" style={{ height: ht, fontWeight: "900", flex: 7, color: "red", textAlign: "center", borderRightWidth: bw2, }}>{(PASS && value?.siddhiGiven) ? "+" + value?.siddhiGiven : ""}</Text>
                                        <Text variant="titleMedium" style={{ height: ht, fontWeight: "900", flex: 7, color: "green", textAlign: "center", }}>{(PASS && value?.kripaGiven) ? "+" + value?.kripaGiven : ""}</Text>
                                    </View>

                                </View>
                                {/* {//console.log(exam)} */}
                                <View style={{ width: "30%", borderTopWidth: bw2, borderBottomWidth: bw2, alignItems: "center", justifyContent: "center" }}>
                                    <View style={{ flexDirection: "row", borderStyle: "solid", alignItems: "center", justifyContent: "center" }}>
                                        <View style={{ justifyContent: "center", alignItems: 'center' }}>
                                            <Text style={{ height: 35 }} variant="titleMedium">પરિણામ </Text>
                                            <Text style={{ height: 35 }} variant="titleMedium">ટકાવારી </Text>
                                            <Text style={{ height: 35 }} variant="titleMedium">પાસ નંબર </Text>
                                        </View>

                                        <View style={{ justifyContent: "center", alignItems: 'center', borderWidth: bw1, borderStyle: "solid", }}>
                                            <Text variant="titleMedium" style={{ height: 35, borderBottomWidth: bw1, fontWeight: "900", textAlign: "center", width: 100, }}>{PASS ? ((value.kripaGiven > 0) ? "ઉપર ચઢાવ્યા" : value.status) : value.status}</Text>
                                            <Text variant="titleMedium" style={{ height: 35, borderBottomWidth: bw1, fontWeight: "900", borderStyle: "solid", width: 100, textAlign: "center" }}> {PASS ? (value?.pc ? value?.pc + " %" : "") : "-"} </Text>
                                            <Text variant="titleMedium" style={{ height: 35, fontWeight: "900", borderStyle: "solid", width: 100, textAlign: "center" }}> {PASS ? (value?.rank ? value?.rank + "" : "-") : "-"}  </Text>
                                        </View>
                                    </View>
                                    <View style={{ flexDirection: "row", borderStyle: "solid", alignItems: "center", justifyContent: "center", marginTop: 30 }}>
                                        <View style={{ justifyContent: "center", alignItems: 'center' }}>
                                            <Text style={{ flex: 1, fontWeight: "bold" }} variant="titleMedium">{value?.totalDays}</Text>
                                            <Text style={{ flex: 1, borderTopWidth: 1 }} variant="titleMedium">કુલ દિવસ</Text>
                                        </View>
                                        <Text style={{ flex: 1 }} variant="titleSmall"> માંથી </Text>

                                        <View style={{ justifyContent: "center", alignItems: 'center', borderStyle: "solid", }}>
                                            <Text style={{ flex: 1, fontWeight: "bold" }} variant="titleMedium">{value?.present}</Text>
                                            <Text style={{ flex: 1, borderTopWidth: 1 }} variant="titleMedium">હાજર દિવસ</Text>
                                        </View>
                                    </View>

                                    <Text style={{ textDecorationLine: "underline", fontWeight: "bold", marginTop: 20 }}>{value?.note}</Text>

                                </View>
                            </div>
                            {route?.params?.blockPrint !== true &&
                                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                                    <div style={{ display: "flex", marginTop: 30, flex: 1, flexDirection: "row" }}>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ flex: 1, textAlign: "center", fontWeight: "bold" }}>વર્ગશિક્ષકની  સહી</Text>
                                            {/* <HelperText style={{ flex: 1, textAlign: "center" }}></HelperText> */}
                                        </View>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ flex: 1, textAlign: "center", fontWeight: "bold" }}>ચેકરની સહી</Text>
                                            {/* <HelperText style={{ flex: 1, textAlign: "center" }}></HelperText> */}
                                        </View>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ flex: 1, textAlign: "center", fontWeight: "bold" }}>આચાર્યની સહી</Text>
                                            {/* <HelperText style={{ flex: 1, textAlign: "center" }}></HelperText> */}
                                        </View>
                                    </div>

                                    <Text style={{ marginTop: 5, marginBottom: 5, flex: 1, textAlign: "center", fontWeight: "bold" }}>{value?.mess}</Text>
                                </div>
                            }
                        </div >
                        {pg1 == 2 && <div className="pagebreak" />}
                    </div>
                })}
            </div>
        </View>
    </ScrollView>
}